export default {"src":"/_next/static/media/EW.0d72d61f.svg","height":18,"width":18};